import { CountryCode } from "shared/types/countryCode";

const EXTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS = [
  "VY_WEB_TRAFFIC_UPDATES",
  "TRAVEL_SEARCH",
]; // Tine (18. Jun 2025): Trafikkstatussiden på vy.no samt i reisesøk.

const INTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS = [
  "DROPS_LOG",
  "DRIFTSTJENESTER",
  "NOTIFICATION_INTERNAL",
  "TRAIN_DRIVER",
  "CUSTOMER_ADVISOR",
  "ENTUR_SORVIS",
  "CONDUCTOR",
  "DROPS",
]; // Astrid (18. Jun 2025): Alle utenom småtroll

const EXTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS_SE = ["NORRTAG"];

const INTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS_SE = ["DROPS_SE"];

export const getCustomInfrastructureContexts = (countryCode: CountryCode) => {
  switch (countryCode) {
    case "SE":
      return [
        ...EXTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS_SE,
        ...INTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS_SE,
      ];
    case "NO":
      return [
        ...EXTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS,
        ...INTERNAL_CUSTOM_INFRASTRUCTURE_CONTEXTS,
      ];
  }
};
